module.exports = __webpack_public_path__ + "static/media/share.aca33b4e.svg";